import { render } from "./onlineorderform.vue?vue&type=template&id=3ab52813"
import script from "./onlineorderform.vue?vue&type=script&lang=js"
export * from "./onlineorderform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__